import { ReactNode } from 'react';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import {
  type ResourceDisplayNameProps,
  extractLastNameComponentFromName,
  extractWorkflowFromInstanceName,
} from '@spotify/confidence-core-react';

import { useWorkflowInstanceRef } from '../../hooks/useWorkflowInstanceRef';
import { workflowInstanceRouteRef } from '../../routes';

export interface WorkflowInstanceResourceLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

export const WorkflowInstanceResourceDisplayName = ({
  name,
  children,
}: ResourceDisplayNameProps) => {
  const { workflowInstance } = useWorkflowInstanceRef({ name });

  return <>{workflowInstance?.displayName || children}</>;
};

export const WorkflowInstanceResourceLink = (
  props: WorkflowInstanceResourceLinkProps,
) => {
  const { name, text, className } = props;

  const routeRef = useRouteRef(workflowInstanceRouteRef);

  const href = routeRef({
    workflow: extractWorkflowFromInstanceName(name) ?? '',
    id: extractLastNameComponentFromName(name),
  });

  return (
    <Link to={href} className={className}>
      {text}
    </Link>
  );
};
